import { GridColDef } from '@mui/x-data-grid-premium';
import TenantPage from 'components/common/TenantPage';
import { DeletedVersionsColumns } from 'components/common/enhanced/common-headers/versions_deleted';
import { EnhancedDataGrid } from 'components/common/enhanced/data-grid';
import { logService } from 'services/api/LogService';
import { useTranslation } from 'react-i18next';

export const DeletedVersionsPage = () => {
  const translationPrefix = 'pages.versions.deleted';
  const { t } = useTranslation();
  const columns: GridColDef[] = DeletedVersionsColumns();

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <div className="mt-6">
        <EnhancedDataGrid
          columns={columns}
          service={logService}
          refresh={null}
          disableDelete
          outerParams={{ action: 2 }}
        />
      </div>
    </TenantPage>
  );
};

export default DeletedVersionsPage;
